
import objectPath from 'object-path'

const getters = {
  getVisas: state => state.visas,
  getToursVisas: state => ({ visaIndex, cityId }) => state.visas[visaIndex].toursVisas.visas
    .find(visa => visa.citySlug === cityId).results,
  getToursVisasIds: state => visaIndex => ({
    id: state.visas[visaIndex].toursVisas.id,
    searchId: state.visas[visaIndex].toursVisas.searchId
  }),
  getVisa: state => visaIndex => state.visas[visaIndex].visas,
  getVisaForm: state => visaIndex => state.visas[visaIndex].form,
  getVisaCities: state => visaIndex => state.visas[visaIndex].cities,
  // eslint-disable-next-line
  getVisaFormForSearch: (state, getters) => ({ touristIndex, visaIndex }) => ({
    countryId: getters.getLocations.countryTo.slug,
    cityId: getters.getVisaForm(visaIndex).cityId[touristIndex],
    currency: getters.getCartPrice.currency
  }),
  getVisaCurrent: state => target => objectPath.get(state, target)
}

export default getters